import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);

    (async () => {
      try {
        const acceptTos = localStorage.getItem("pending_tos_accept") === "1";
        const { data } = await api.post("/auth/google/session", { session_id, accept_terms: acceptTos });
        localStorage.removeItem("pending_tos_accept");
        // CRITICAL: persist JWT bearer to localStorage so subsequent API calls authenticate
        // even when the HttpOnly session cookie is dropped on 3rd-party redirects (e.g. Stripe).
        if (data.token) localStorage.setItem("inbox_token", data.token);
        setUser(data);

        let destination = "/pricing";
        try {
          const { data: access } = await api.get("/access");
          if (access.subscription_active || access.active_pass) {
            destination = "/dashboard";
          }
        } catch (e) {
          // if access check fails, default to /pricing
        }

        window.history.replaceState({}, document.title, destination);
        toast.success(`Welcome, ${data.name || data.email}`);
        navigate(destination, { replace: true });
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center font-mono text-sm">
      Establishing session…
    </div>
  );
}